// Footer.js
import React, { useEffect } from "react";
import logo2 from "../../assets/logo2.png";

import { ImTwitter } from "react-icons/im";
import { PiInstagramLogoFill } from "react-icons/pi";
import { FaFacebookF,FaLinkedin  } from "react-icons/fa";

const Footer = () => {
 
  return (
    <>
    <footer className="w-full border-t border-gray-200 px-4 py-10 flex flex-col md:flex-row" style={{fontFamily:"Gilroy-Medium"}}>
      <div className="w-full md:w-2/5 md:px-20">
        <h3 className="mb-2 font-medium">
          <img src={logo2} alt="inggage" className="w-24" />
        </h3>
       
        <p className="text-black text-sm leading-6 font-medium">
        AI-powered influencer marketing 
        platform
        </p>
      </div>
  
      <div className="w-full md:w-3/5 flex flex-col md:flex-row mt-6 md:mt-0">
        <div className="flex-1 flex flex-col ml-3">
          <h4 className="mb-2 font-medium">Information</h4>
          <ul className="list-none p-0">
            <li className="text-black text-sm font-light mb-2 hover:underline cursor-pointer">FAQ</li>
            <li className="text-black text-sm font-light mb-2 hover:underline cursor-pointer">Blog</li>
            <li className="text-black text-sm font-light mb-2 hover:underline cursor-pointer">Support</li>
            <li className="text-black text-sm font-light mb-2 hover:underline cursor-pointer">Help</li>
          </ul>
        </div>
        <div className="flex-1 flex flex-col ml-3">
          <h4 className="mb-2 font-medium">Company</h4>
          <ul className="list-none p-0">
            <li className="text-black text-sm font-light mb-2 hover:underline cursor-pointer">About us</li>
            <li className="text-black text-sm font-light mb-2 hover:underline cursor-pointer">Careers</li>
            <li className="text-black text-sm font-light mb-2 hover:underline cursor-pointer">Contact us</li>
            <li className="text-black text-sm font-light mb-2 hover:underline cursor-pointer">Features</li>
          </ul>
        </div>

       
<div className="flex-1 flex flex-col ml-3">  
<h4 className="mb-2 font-medium">Follow Us</h4>
        <div className="flex gap-2 mb-3 h-7">
          
          <a href="https://www.instagram.com/inggage/" target="_blank" rel="noopener noreferrer">
            <PiInstagramLogoFill className="text-black text-xl hover:text-pink-600" />
          </a>
          <a href="https://www.instagram.com/inggage/" target="_blank" rel="noopener noreferrer">
            <FaFacebookF className="text-black text-xl hover:text-pink-600" />
          </a>
          <a href="https://www.instagram.com/inggage/" target="_blank" rel="noopener noreferrer">
            <ImTwitter className="text-black text-xl hover:text-pink-600" />
          </a>
          <a href="https://www.linkedin.com/company/inggage/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin className="text-black text-xl hover:text-pink-600" />
          </a>
        </div>
        </div>

      </div>
    </footer>
  
    <div className="bg-black text-white py-2 flex justify-center items-center">
      <p className="text-white text-sm font-medium">© 2025 Inggage. All rights reserved.</p>
    </div>
  </>
  );
};

export default Footer;
